export default "__VITE_ASSET__BLsrm_m4__"